export enum SummaryTypeEnum {
  campaign = 'campaign',
  emitter = 'emitter',
  company = 'company',
  map = 'map',
  category = 'category',
}
